var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolkaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5398 20.7264C15.1552 20.7264 14.9146 20.3104 15.1064 19.977L21.8555 8.25059C21.9447 8.09556 22.11 8 22.2888 8H23.6474C24.0292 8 24.2701 8.41067 24.0838 8.74396L17.5292 20.4704C17.4408 20.6285 17.2739 20.7264 17.0927 20.7264H15.5398Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 8,
    width: 10,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5398 20.7264C15.1552 20.7264 14.9146 20.3104 15.1064 19.977L21.8555 8.25059C21.9447 8.09556 22.11 8 22.2888 8H23.6474C24.0292 8 24.2701 8.41067 24.0838 8.74396L17.5292 20.4704C17.4408 20.6285 17.2739 20.7264 17.0927 20.7264H15.5398Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 12.5L22.0162 12.589L24.6269 8H21.4998L18.9998 12.5Z",
    fill: "url(#paint0_linear)"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4651 9.78023C23.3721 9.91766 23.217 10 23.051 10H9.25C9.09262 10 8.94443 9.9259 8.85 9.8L8.1 8.8C7.85279 8.47038 8.08798 8 8.5 8H23.7278C24.1287 8 24.3666 8.44819 24.1419 8.78023L23.4651 9.78023Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1301 11.9999C17.5147 11.9999 17.7553 12.416 17.5635 12.7493L10.8144 24.4757C10.7252 24.6308 10.56 24.7263 10.3811 24.7263H9.02252C8.6407 24.7263 8.39978 24.3156 8.58607 23.9824L15.1407 12.2559C15.2291 12.0978 15.3961 11.9999 15.5772 11.9999H17.1301Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 11,
    width: 10,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1301 11.9999C17.5147 11.9999 17.7553 12.416 17.5635 12.7493L10.8144 24.4757C10.7252 24.6308 10.56 24.7263 10.3811 24.7263H9.02252C8.6407 24.7263 8.39978 24.3156 8.58607 23.9824L15.1407 12.2559C15.2291 12.0978 15.3961 11.9999 15.5772 11.9999H17.1301Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6699 20.226L10.6535 20.137L8.04273 24.726H11.1699L13.6699 20.226Z",
    fill: "url(#paint1_linear)"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20482 22.9463C9.29783 22.8089 9.45296 22.7266 9.61891 22.7266H22.75C22.9074 22.7266 23.0556 22.8007 23.15 22.9266L23.9 23.9266C24.1472 24.2562 23.912 24.7266 23.5 24.7266H8.94218C8.54126 24.7266 8.30339 24.2784 8.52809 23.9463L9.20482 22.9463Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.5923,
    y1: 8,
    x2: 21.5923,
    y2: 12.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF98FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 11.0774,
    y1: 24.726,
    x2: 11.0774,
    y2: 20.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF98FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkaIcon);
export default __webpack_public_path__ + "static/media/polka-icon.d8f182ca.svg";
export { ForwardRef as ReactComponent };